import React, { useState, useEffect } from 'react';
import Highcharts from 'highcharts'
import xrange from 'highcharts/modules/xrange.js';

import ThemedChartLight from "./ThemedChartLight";
import ThemedChartDark from "./ThemedChartDark";
import { ChartArea } from "../styled/Stockchart.styled";
import styles from "../utils/themeStyles";
import { useVsiAppContext } from "../stores/VsiApp";
import { withErrorBoundary } from "../boundaries/withErrorBoundary";
import GeneralErrorBoundary from "../boundaries/GeneralErrorBoundary";
xrange(Highcharts)

function XRangeChart({ categories, data, title, min, max, height, mutable }) {
  const { theme } = useVsiAppContext();
  const basicTextStyle = {
    color: styles[theme].textColor,
    fontFamily: styles[theme].fontFamily,
  };

    const [chartOptions, setChartOptions] = useState(
      {
      // To avoid unnecessary update keep all options in the state.

        chart: {
          type: 'xrange',
          height:  height,
          backgroundColor: "transparent",
          color: styles[theme].textColor,
        },
        credits: {
          enabled: false,
        },
        mapNavigation: {
          enabled: false
        },
        title: {
          text: title || ""
        },
        xAxis: {
          type: 'datetime',
          min: min || null,
          max: max || null,
        },
        tooltip: {
          backgroundColor: styles[theme].altBgColor,
          style: basicTextStyle,
        },
        yAxis: {
          title: {
            text: ''
          },
          categories: categories,
          // reversed: true
        },
        legend: {
          enabled: false,
        },
        series: [{
          data: data,
          dataLabels: {
            enabled: true,
          },
          name: 'Device Name'
        }],
      });

    useEffect(() => {
      setChartOptions({
        // To avoid unnecessary update keep all options in the state.

        chart: {
          type: 'xrange',
          height:  height,
          backgroundColor: "transparent",
          color: styles[theme].textColor,
        },
        mapNavigation: {
          enabled: false
        },
        title: {
          text: title || ""
        },
        xAxis: {
          type: 'datetime',
          min: min || null,
          max: max || null,
          labels: {
            style: basicTextStyle,
          },
        },
        tooltip: {
          backgroundColor: styles[theme].altBgColor,
          style: basicTextStyle,
        },
        yAxis: {
          title: {
            text: ''
          },
          labels: {
            style: basicTextStyle,
          },
          categories: categories,
          // reversed: true
        },
        legend: {
          enabled: false,
        },
        series: [{
          data: data,
          dataLabels: {
            enabled: true,
          }
        }],
      })
    }, [data, height, title, min, max, categories, theme]);

  return (
      <ChartArea>
        {"light" ? (
          <ThemedChartLight options={chartOptions}
                            mutable={mutable}/>
        ): (
          <ThemedChartDark options={chartOptions}
                           mutable={mutable}/>
        )}
      </ChartArea>
    );
}

XRangeChart.displayName = "XRangeChart"

export default withErrorBoundary(XRangeChart, GeneralErrorBoundary);
